import { useState, useEffect, useRef } from "react";
export default function ProductsOverview() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return <section style={{
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(244, 244, 243)",
    fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
    animation: "none 0s ease 0s 1 normal none running",
    backgroundColor: "#0b0b0d"
  }} className="w-full">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600&display=swap');
        .products-eyebrow::before {
          content: "";
          width: 8px;
          height: 8px;
          background: #f5c518;
          display: inline-block;
          flex-shrink: 0;
        }
        .product-card {
          transition: border-color 0.16s ease, background-color 0.16s ease;
        }
        .product-card:hover {
          border-color: rgba(255,255,255,0.22) !important;
          background-color: #1a1a1e !important;
        }
        .explore-link {
          transition: opacity 0.15s ease;
        }
        .explore-link:hover {
          opacity: 0.75;
        }
      `}</style>

      <div className="w-full" style={{
      paddingTop: "132px",
      paddingBottom: "132px"
    }}>
        <div className="page-container">
          <div ref={ref} className={`transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <div className="products-eyebrow" style={{
            fontFamily: '"Geist Mono", "JetBrains Mono", ui-monospace, "SF Mono", Menlo, monospace',
            fontSize: "0.72rem",
            letterSpacing: "0.22em",
            textTransform: "uppercase",
            color: "#76767d",
            display: "inline-flex",
            alignItems: "center",
            gap: "0.6em",
            marginBottom: "1.2rem"
          }}>
              TWO OPEN-SOURCE PROJECTS
            </div>

            <h2 style={{
            color: "rgb(244, 244, 243)",
            fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
            fontSize: "41.6px",
            fontWeight: "600",
            lineHeight: "43.264px",
            letterSpacing: "-1.248px",
            border: "0px none rgb(244, 244, 243)",
            animation: "none 0s ease 0s 1 normal none running",
            marginBottom: "40px"
          }}>
              A model, and the engine<br />that makes it run.
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2" style={{
            gap: "18px"
          }}>
              <a href="#" className="product-card block" style={{
              color: "rgb(244, 244, 243)",
              fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
              fontSize: "17px",
              fontWeight: "400",
              lineHeight: "27.2px",
              letterSpacing: "-0.187px",
              backgroundColor: "rgb(20, 20, 23)",
              borderRadius: "16px",
              border: "1px solid rgba(255, 255, 255, 0.09)",
              padding: "26px",
              animation: "none 0s ease 0s 1 normal none running",
              textDecoration: "none"
            }}>
                <div className="flex items-center justify-between" style={{
                marginBottom: "16px"
              }}>
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707747/img/orchid-logo.png" alt="Orchid logo" className="h-auto" style={{
                  width: "52px",
                  height: "52px",
                  objectFit: "contain"
                }} />
                  <div style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "5px",
                  backgroundColor: "#1a1a1e",
                  border: "1px solid rgba(255,255,255,0.09)",
                  borderRadius: "20px",
                  paddingInline: "10px",
                  paddingBlock: "4px",
                  fontSize: "13px",
                  color: "#f4f4f3",
                  fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif'
                }}>
                    <span style={{
                    width: "7px",
                    height: "7px",
                    borderRadius: "50%",
                    backgroundColor: "#f5c518",
                    display: "inline-block",
                    flexShrink: 0
                  }} />
                    Model
                  </div>
                </div>

                <h3 style={{
                color: "rgb(244, 244, 243)",
                fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
                fontSize: "24.8px",
                fontWeight: "600",
                lineHeight: "25.792px",
                letterSpacing: "-0.496px",
                border: "0px none rgb(244, 244, 243)",
                animation: "none 0s ease 0s 1 normal none running",
                marginBottom: "10px"
              }}>
                  Orchid 1.0
                </h3>

                <p style={{
                color: "rgb(185, 185, 189)",
                fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
                fontSize: "17px",
                fontWeight: "400",
                lineHeight: "27.2px",
                letterSpacing: "-0.187px",
                border: "0px none rgb(185, 185, 189)",
                animation: "none 0s ease 0s 1 normal none running",
                marginBottom: "20px"
              }}>
                  The first competitive LLM trained and aligned in Colombia. Aligned with ORPO for unbiased, multilingual responses on consumer hardware — no cloud dependency.
                </p>

                <span className="explore-link" style={{
                color: "#f5c518",
                fontFamily: '"Geist Mono", "JetBrains Mono", ui-monospace, "SF Mono", Menlo, monospace',
                fontSize: "14px",
                fontWeight: "400",
                display: "inline-block",
                cursor: "pointer"
              }}>
                  Explore the model →
                </span>
              </a>

              <a href="#" className="product-card block" style={{
              color: "rgb(244, 244, 243)",
              fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
              fontSize: "17px",
              fontWeight: "400",
              lineHeight: "27.2px",
              letterSpacing: "-0.187px",
              backgroundColor: "rgb(20, 20, 23)",
              borderRadius: "16px",
              border: "1px solid rgba(255, 255, 255, 0.09)",
              padding: "26px",
              animation: "none 0s ease 0s 1 normal none running",
              textDecoration: "none"
            }}>
                <div className="flex items-center justify-between" style={{
                marginBottom: "16px"
              }}>
                  <div style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px"
                }}>
                    <div style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#1a1a1e",
                    border: "1px solid rgba(255,255,255,0.16)",
                    borderRadius: "6px",
                    width: "28px",
                    height: "28px",
                    fontFamily: '"Geist Mono", "JetBrains Mono", ui-monospace, monospace',
                    fontSize: "12px",
                    color: "#f4f4f3",
                    fontWeight: "400"
                  }}>
                      −1
                    </div>
                    <div style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#1a1a1e",
                    border: "1px solid rgba(255,255,255,0.16)",
                    borderRadius: "6px",
                    width: "28px",
                    height: "28px",
                    fontFamily: '"Geist Mono", "JetBrains Mono", ui-monospace, monospace',
                    fontSize: "12px",
                    color: "#f4f4f3",
                    fontWeight: "400"
                  }}>
                      0
                    </div>
                    <div style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#f5c518",
                    border: "1px solid rgba(255,255,255,0.16)",
                    borderRadius: "6px",
                    width: "28px",
                    height: "28px",
                    fontFamily: '"Geist Mono", "JetBrains Mono", ui-monospace, monospace',
                    fontSize: "12px",
                    color: "#1a1500",
                    fontWeight: "600"
                  }}>
                      +1
                    </div>
                  </div>

                  <div style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "5px",
                  backgroundColor: "#1a1a1e",
                  border: "1px solid rgba(255,255,255,0.09)",
                  borderRadius: "20px",
                  paddingInline: "10px",
                  paddingBlock: "4px",
                  fontSize: "13px",
                  color: "#f4f4f3",
                  fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif'
                }}>
                    <span style={{
                    width: "7px",
                    height: "7px",
                    borderRadius: "50%",
                    backgroundColor: "#2ea84f",
                    display: "inline-block",
                    flexShrink: 0
                  }} />
                    Engine
                  </div>
                </div>

                <h3 style={{
                color: "rgb(244, 244, 243)",
                fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
                fontSize: "24.8px",
                fontWeight: "600",
                lineHeight: "25.792px",
                letterSpacing: "-0.496px",
                border: "0px none rgb(244, 244, 243)",
                animation: "none 0s ease 0s 1 normal none running",
                marginBottom: "10px"
              }}>
                  ternative
                </h3>

                <p style={{
                color: "rgb(185, 185, 189)",
                fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
                fontSize: "17px",
                fontWeight: "400",
                lineHeight: "27.2px",
                letterSpacing: "-0.187px",
                border: "0px none rgb(185, 185, 189)",
                animation: "none 0s ease 0s 1 normal none running",
                marginBottom: "20px"
              }}>
                  The inference engine for ternary-weight LLMs with runtime LoRA — "the llama.cpp of BitNet models." It serves combinations no other stack can run correctly.
                </p>

                <span className="explore-link" style={{
                color: "#f5c518",
                fontFamily: '"Geist Mono", "JetBrains Mono", ui-monospace, "SF Mono", Menlo, monospace',
                fontSize: "14px",
                fontWeight: "400",
                display: "inline-block",
                cursor: "pointer"
              }}>
                  How it works →
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}